<template>
  <div>
    <!-- Footer -->
    <footer class="site-footer style-1 position-relative">
      <!-- <div class="footer-top bg-light sapping">
        <div class="container">
          <div class="row p-50">
            <div class="col-lg-3 col-md-12 col-sm-12">
              <div
                class="widget wow fadeInUp text-center text-lg-start"
                data-wow-delay="1.4s"
              >
                <div class="footer-logo">
                  <a href="index.html" class="logo-dark"
                    ><img src="assets/images/Explore2Teach_Logo.png" alt=""
                  /></a>
                </div>
                <div class="widget_getintuch">
                  <ul>
                    <li class="text-center">
                      <i class="fa-regular fa-comments"></i>
                      support@explore2teach.com
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                  <div
                    class="widget widget_links wow fadeInUp"
                    data-wow-delay="1.6s"
                  >
                    <h4 class="footer-title">Links</h4>
                    <ul>
                      <li><a href="javascript:void(0);">About Us</a></li>
                      <li><a href="javascript:void(0);">Contact Us</a></li>
                      <li><a href="javascript:void(0);">Affiliates</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                  <div
                    class="widget widget_links wow fadeInUp"
                    data-wow-delay="1.8s"
                  >
                    <h4 class="footer-title">Category</h4>
                    <ul>
                      <li><a href="javascript:void(0);">UI Designer</a></li>
                      <li><a href="javascript:void(0);">UX Designer</a></li>
                      <li><a href="javascript:void(0);">Grapic Designer</a></li>
                      <li><a href="javascript:void(0);">Web Developers</a></li>
                      <li><a href="javascript:void(0);">More</a></li>
                    </ul>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-6">
                  <div
                    class="widget widget_links wow fadeInUp"
                    data-wow-delay="2.0s"
                  >
                    <h4 class="footer-title">Follow Us</h4>
                    <ul>
                      <li>
                        <a
                          href="https://www.facebook.com/explore2teach"
                          target="_blank"
                          >Facebook</a
                        >
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/explore2teach"
                          target="_blank"
                          >Instagram</a
                        >
                      </li>
                      <li><a href="javascript:void(0);">Linked In </a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-12 col-sm-12">
              <div class="widget wow fadeInUp" data-wow-delay="2.2s">
                <h4 class="footer-title">Newsletter</h4>
                <p>Sign up to our archi. point to recent updates & office</p>
                <form
                  class="dzSubscribe ft-subscribe mb-4"
                  action="assets/script/mailchamp.php"
                  method="post"
                >
                  <div class="dzSubscribeMsg"></div>
                  <div class="input-group mb-0">
                    <input
                      name="dzEmail"
                      required="required"
                      type="email"
                      class="form-control"
                      placeholder="Your Email Address"
                    />
                    <button
                      name="submit"
                      value="Submit"
                      type="submit"
                      class="btn btn-primary style-1"
                    >
                      Send
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="footer-bottom text-md-center text-md-center bg-light">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="footer-inner text-center">
                <p class="copyright-text wow fadeInUp" >
                  {{pageContent.copyright}}

                  <a
                    class="text-primary"
                    href="javascript:void(0);"
                    target="_blank"
                    >Explore2Teach</a
                  >. {{pageContent.reserved}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer End -->
  </div>
</template>

<style>
footer {
  position: relative;
  z-index: 2;
  background: white;
}
</style>

<script>
export default {
  props: {
    pageContent: {
      type: Object,
      required: true,
    },
  },
};
</script>